import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, TextInput, DateInput, CheckBoxInput } from '../../components/common/components'
import { setFormValue, getAreaCode, submit, getSchdTimeOptions } from '../../actions'
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import { doPost } from '../../utils/AjaxRequests';
import { apiPrefixUrl } from '../../utils/connection';
import { weeks } from '../../utils/utils';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function InformationForm() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    let history = useHistory();

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const dispatch = useDispatch()

    let query = useQuery();

    let schd_type = query.get("schd_type")

    const handlechange = useCallback((field, value) => {
        const inputValue = field === "PAT_IDNO" ? value.toUpperCase() : value

        dispatch(setFormValue({
            field,
            value: inputValue
        }))

    }, [dispatch])


    const [captchaing, setCaptchaing] = useState(false)

    const [captcha, setCaptcha] = useState(null)

    const [capImg, setCapImg] = useState(null)

    const [captchaInput, setCaptchaInput] = useState("")

    const [showName, setShowName] = useState({
        consult:"",
        time:""
    })

    const loadCaptcha = useCallback(
        () => {
            setCaptchaing(true)
            const fetchGetConfig = {
                method: 'GET',
                credentials: 'include'
            }
            //   var myImage = document.querySelector('#captcha202010190819')
            var imageUrl = `https://staff.kfsyscc.org/ca/captcha.jpg`

            fetch(imageUrl, fetchGetConfig).then((res) => {
                return res.blob()
            }).then((res) => {
                var objcetURL = URL.createObjectURL(res)
                setCapImg(objcetURL);

                fetch(`https://staff.kfsyscc.org/ca/digits`, fetchGetConfig).then((res) => {

                    return res.json()
                }).then((data) => {
                    // console.log(data)
                    //   if (!IS_PROD) {
                    //     setCaptcha('9999')
                    //   }
                    //   else {
                    setCaptcha(data.digit)
                    //   }
                    setCaptchaing(false)
                })
            })
        },
        [],
    );

    useEffect(() => {
        loadCaptcha()

        let timerFunc = setTimeout(() => {
            if (!schd_type) {
                history.push('/')
            } else if (!form.schdTimeId) {
                history.push(`/second_step?schd_type=${schd_type}`)
            }
        }, 700);

        return () => clearTimeout(timerFunc);

    }, [])


    const getShowName = useCallback(async () => {

        if(!form.consult || !schd_type || !form.schdTimeId){
            return
        }

        const consultData = await doPost(apiPrefixUrl, {
            "api": "APCSchdTypesV2",
            "SPNO": "",
            "USER_ID": "patient"
        })

        if (consultData.status) {
            const selectedConsult = _.filter(
                _.get(
                    _.find(consultData.data, (o) => o.SCHD_TYPE === schd_type), 'CONSULT_OPTIONS')
                , (i) => (form.consult.split(",")).includes(i.CODE_NO)
            )

        

            setShowName((prev)=>{
                let txt = (_.map(selectedConsult, 'CODE_NAME')).toString()
 
                return {...prev, consult:txt}
            }) 
            
            
            const timeData = await doPost(apiPrefixUrl, {
                "api":"APCSchdsetsV2",
                "SCHD_TYPE":schd_type,
                "CONSULT_OPTIONS":form.consult,
                "SPNO":"",
                "USER_ID":"patient"
            })

            if(timeData.status){
                const timeSelected = _.find(timeData.data.SCHDSETS, (o)=>o.SCHD_ID_STR === form.schdTimeId)

                setShowName((prev)=>{
                    let txt = `${timeSelected.START_DATE_STR}(${weeks[timeSelected.DAYS_STR]}) ${timeSelected.NOON_STR}`
                    return {...prev, time:txt}
                }) 
            }
        }

    }, [form.consult, schd_type, form.schdTimeId])


    useEffect(() => {
        getShowName()
    }, [getShowName])

    const handleAddressChange = useCallback((field, value) => {
        const preForm = _.cloneDeep(form)
        dispatch(setFormValue({
            field,
            value
        }))
        if (field === "city" && value !== preForm[field]) {
            dispatch(setFormValue({ field: "AREA_CODE", value: "" }))
            dispatch(getAreaCode())
        }

    }, [dispatch, form])



    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            <div style={{paddingLeft:"10px"}}>
                <Typography variant="subtitle1" gutterBottom align="left">
                    預約項目：{showName.consult}
                </Typography>
                <Typography variant="subtitle1" gutterBottom align="left">
                    預約時間：{showName.time}
                </Typography>
            </div>
            
            {/* <SelectInput
                label={`${form.schdTypeName}`}
                field="conformId"
                value={form.conformId}
                setValue={handlechange}
                options={JSON.stringify(option.conform)}
                disabled
            />
            <SelectInput
                label={`預約時間`}
                field="schdTimeId"
                value={form.schdTimeId}
                setValue={handlechange}
                options={JSON.stringify(option.schdTime)}
                disabled
            /> */}
            {/* {schd_type === "A5" ? <TextInput
                label="預約代碼"
                field="TICKET_NO"
                value={form.TICKET_NO}
                setValue={handlechange}
                variant="outlined"
                disabled
            /> : null} */}
            <Grid container>
                {/* <Grid item xs={12}>
                    <CheckBoxInput
                        label="無中華民國身分證號"
                        field="NO_ROC_ID"
                        value={form.NO_ROC_ID}
                        setValue={handlechange}
                    />
                </Grid> */}
                <Grid item xs={6}>
                    <TextInput
                        label="中文姓名(同身分證文件)*"
                        field="PAT_NAME"
                        value={form.PAT_NAME}
                        setValue={handlechange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput
                        label={`身分證字號*`}
                        field="PAT_IDNO"
                        value={form.PAT_IDNO}
                        setValue={handlechange}
                    // disabled
                    />
                </Grid>
                {/* <Grid item xs={6}>
                    <SelectInput
                        label="居住縣/市"
                        field="city"
                        value={form.city}
                        setValue={handleAddressChange}
                        options={JSON.stringify(option.city)}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        label="居住鄉鎮市區"
                        field="AREA_CODE"
                        value={form.AREA_CODE}
                        setValue={handleAddressChange}
                        options={JSON.stringify(option.AREA_CODE)}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextInput
                        label="居住居住路街/里鄰巷弄/號樓"
                        field="ADDRESS"
                        value={form.ADDRESS}
                        setValue={handlechange}
                    />
                </Grid> */}


                {/* <Grid item xs={6}>
                    <TextInput
                        label="英文姓名(若需要請務必同護照)"
                        field="PASSPORT_NAME"
                        value={form.PASSPORT_NAME}
                        setValue={handlechange}
                    />
                </Grid> */}

                {/* <Grid item xs={6}>
                    <TextInput
                        label="居留證號碼(若需要請務必同居留證)"
                        field="RC_NUMBER"
                        value={form.RC_NUMBER}
                        setValue={handlechange}
                    />
                </Grid> */}
                {/* <Grid item xs={6}>
                    <TextInput
                        label="國籍(若需要請填英文)"
                        field="NATIONALITY"
                        value={form.NATIONALITY}
                        setValue={handlechange}
                    />
                </Grid> */}

                {/* <Grid item xs={6}>
                    <TextInput
                        label="護照證字號(若需要請務必同護照)"
                        field="PASSPORT_NUMBER"
                        value={form.PASSPORT_NUMBER}
                        setValue={handlechange}
                    />
                </Grid> */}

                <Grid item xs={6}>
                    <SelectInput
                        label="性別"
                        field="SEX"
                        value={form.SEX}
                        setValue={handlechange}
                        options={JSON.stringify(option.gender)}
                        variant="standard"
                    />
                </Grid>
                {/* <Grid item xs={6}>
                    <DateInput
                        label="出生年月日"
                        field="BIRTHDAY"
                        setValue={handlechange}
                        value={form.BIRTHDAY}
                    // disabled
                    />
                </Grid> */}
                <Grid item xs={6}>
                    <DateInput
                        label="出生年月日 (1900/01/01)*"
                        field="BIRTHDAY"
                        setValue={handlechange}
                        value={form.BIRTHDAY}
                    // disabled
                    />
                </Grid> 
                <Grid item xs={6}>
                    <TextInput
                        label="手機號碼 (09xxxxxxxx)*"
                        field="TEL_MOBILE"
                        value={form.TEL_MOBILE}
                        setValue={handlechange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextInput
                        label="e-mail (選填)"
                        field="EMAIL"
                        value={form.EMAIL}
                        setValue={handlechange}
                    />
                </Grid>



                {/* <Grid item xs={6}></Grid> */}

                <Grid item xl={2} lg={4} md={4} sm={6} xs={6}>
                    <TextInput
                        label="驗證碼"
                        field="captchaInput"
                        value={captchaInput}
                        setValue={(field, value) => { setCaptchaInput(value) }}
                    />
                </Grid>
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6} style={{ padding: "5px" }}>
                    {capImg ? <img alt="captcha" src={capImg} style={{ height: "80%", objectFit: "contain" }} /> : null}
                </Grid>
                <Grid item xl={2} lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                    <Button color="primary" variant="contained" onClick={() => loadCaptcha()}>取得新驗證碼</Button>
                </Grid>
            </Grid>
            {form.loading ?
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress size={200} />
                </div> : null}

        </Paper>
        {!form.loading ? <>
            <Button
                variant="contained"
                style={{ margin: "30px" }}
                onClick={() => { history.goBack() }}
            >
                上一步
            </Button>
            <Button
                variant="contained"
                color="primary"
                style={{ margin: "30px" }}
                onClick={() => {
                    if (captcha === "" || captcha !== captchaInput) {
                        Swal.fire("驗證碼不符", "", "error")
                        return
                    }
                    dispatch(submit(schd_type))
                }}
            >
                送出
            </Button>

        </> : null}

    </Box>
}
